import React from "react";
import styled, { keyframes, css } from "styled-components";

interface DotProps {
  delay: string;
  color: string;
}

const pulse = (color: string) => keyframes`
  0% {
    transform: scale(0.8);
    background-color: ${color}CC;
    box-shadow: 0 0 0 0 ${color}B3;
  }
  50% {
    transform: scale(1.2);
    background-color: ${color};
    box-shadow: 0 0 0 10px ${color}00;
  }
  100% {
    transform: scale(0.8);
    background-color: ${color}CC;
    box-shadow: 0 0 0 0 ${color}B3;
  }
`;

const DotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 12px;
`;

const Dot = styled.div<DotProps>`
  height: 8px;
  width: 8px;
  margin-right: 6px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  animation: ${(props) =>
    css`
      ${pulse(props.color)} 1.5s infinite ease-in-out
    `};
  animation-delay: ${(props) => props.delay};

  &:last-child {
    margin-right: 0;
  }
`;

interface DotLoaderProps {
  color?: string; // Accept hex code or any valid CSS color
}

const DotLoader: React.FC<DotLoaderProps> = ({ color = "#6793fb" }) => (
  <DotsContainer>
    <Dot color={color} delay="-0.3s" />
    <Dot color={color} delay="-0.1s" />
    <Dot color={color} delay="0.1s" />
    <Dot color={color} delay="0.3s" />
    <Dot color={color} delay="0.5s" />
  </DotsContainer>
);

export default DotLoader;
